import { Combine, Filter, FolderTree } from 'lucide-react';
import Catalogo from '../catalogo-vivo/Catalogo';
import UbicacionesRepetidas from '../catalogo-vivo/UbicacionesRepetidas';
import VistasInventario from '../catalogo-vivo/VistasInventario';

/* =====================================================================
   Las pantallas del carril `catalogo-vivo` · DIRECTRIZ-CATALOGO-VIVO
   =====================================================================
   F1 · «Catálogo» en Administración (R-CV7): categorías en árbol,
   plantillas listas, fichas incompletas y (F4) etiquetas. Se ve desde
   CONSULTA porque leer no cambia nada; lo que escribe pide su rango o su
   permiso, y la pantalla apaga con motivo lo que no se puede.
   F3.7 · «Ubicaciones repetidas» en Administración, con el permiso de la
   fusión que las junta (`reorganizar_sitios`, ADMIN y DUEÑO). El selector
   de ubicación (`catalogo-vivo/SelectorUbicacion.jsx`) no es una pantalla:
   lo usan las fichas que eligen dónde va algo.
   F4 · «Vistas del inventario» en Operación: chips de etiqueta, filtros y
   vistas guardadas sobre la lista de productos.
   ===================================================================== */
export default {
  orden: 42,
  grupos: [
    {
      grupo: 'Operación',
      items: [
        { id: 'vistas-inventario', etiqueta: 'Vistas del inventario', icono: Filter, min: 'CONSULTA', Comp: VistasInventario },
      ],
    },
    {
      grupo: 'Administración',
      items: [
        { id: 'catalogo', etiqueta: 'Catálogo', icono: FolderTree, min: 'CONSULTA', Comp: Catalogo },
        { id: 'ubicaciones-repetidas', etiqueta: 'Ubicaciones repetidas', icono: Combine,
          permiso: 'reorganizar_sitios', min: 'ADMIN', Comp: UbicacionesRepetidas },
      ],
    },
  ],
};
